"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ramda = require("ramda");

var _material = require("@mui/material");

var _CalendarSetting = require("./CalendarSetting.shape");

var timeFormat = 'h:mm A';
var getEnabledDays = (0, _ramda.filter)((0, _ramda.propEq)('enabled', true));

var formatSlotTime = function formatSlotTime(acc, slot) {
  return "".concat(acc, " ").concat(slot.from.format(timeFormat), " - ").concat(slot.till.format(timeFormat), ", ");
};

var formatDaySlots = (0, _ramda.pipe)((0, _ramda.reduce)(formatSlotTime, ''), (0, _ramda.slice)(0, -2));

var CalendarSettingValues = function CalendarSettingValues(_ref) {
  var days = _ref.days;
  var enabledDays = (0, _react.useMemo)(function () {
    return getEnabledDays(days);
  }, [days]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, enabledDays.map(function (item) {
    return /*#__PURE__*/_react.default.createElement(_material.Box, {
      key: item.id,
      "data-testid": "Settings.Calendar.".concat(item.dayName),
      display: "flex",
      justifyContent: "flex-start"
    }, /*#__PURE__*/_react.default.createElement("span", {
      style: {
        minWidth: 100
      }
    }, "".concat(item.dayName, ":")), /*#__PURE__*/_react.default.createElement("span", null, "".concat(formatDaySlots(item.slots), ".")));
  }));
};

CalendarSettingValues.propTypes = {
  days: _propTypes.default.arrayOf(_CalendarSetting.CalendarDay).isRequired
};

var _default = /*#__PURE__*/(0, _react.memo)(CalendarSettingValues);

exports.default = _default;